<template>
  <SloLoader :loading="loading" size="xl">
    <OrderReturn :order="order" :return-reasons="returnReasons" class="my-xl md:my-2xl" />
  </SloLoader>
</template>

<script>
import t from '../../main/i18n';
import {handleApiErrors} from '../../main/utils';
import {marketplaceApi} from '../apis/marketplace';
import OrderReturn from '../components/OrderReturn.vue';
import SloLoader from '../../../lib/components/SloLoader.vue';

export default {
  components: {
    OrderReturn,
    SloLoader
  },
  data() {
    return {
      loading: false,
      order: null,
      returnReasons: null
    };
  },
  async created() {
    this.loading = true;

    const code = this.$route.query?.code;
    const email = this.$route.query?.email;
    const billZip = this.$route.query?.billZip;

    if (!code || !email || !billZip) {
      this.$snotify.error(t('Insufficient order information provided'));
      await this.$router.push({name: 'marketplace'});
    }

    await marketplaceApi.getOrder({code, email, billZip})
      .then(async res => {
        const orderStatus = res.data?.orderStatus;
        if (orderStatus !== 'S003' && orderStatus !== 'S009') {
          this.$snotify.error(t('Order cannot be returned'));
          await this.$router.push({name: 'marketplace-account-orders'});
          return;
        }

        this.order = res.data;
      })
      .catch(async e => {
        handleApiErrors(e, this, 'Error retrieving order details');
        await this.$router.push({name: 'marketplace'});
      });

    await marketplaceApi.getReturnReasons()
      .then(res => {
        this.loading = false;
        this.returnReasons = res.data;
      })
      .catch(async() => {
        this.$snotify.error(t('Error retrieving return reasons'));
        await this.$router.push({name: 'marketplace-account-orders'});
      });
  }
};
</script>
